<template>
    <div>
        <portal to="page-header">{{ $t('Accounting') }}</portal>

        <portal to="actions">
            <a  class="px-4 py-2 font-medium uppercase leading-5 text-white bg-purple-600 rounded border border-transparent active:bg-purple-600 hover:bg-purple-700 focus:outline-none focus:shadow-outline-gray whitespace-no-wrap" :href="route('stats.accounting.export', { from, to})" target="_blank">
                <span class="hidden sm:inline">{{ $t('Export') }}</span>
            </a>
        </portal>

        <div class="flex flex-wrap">
            <div class="sm:px-1 md:px-3 lg:px-3 xl:px-3 w-full">
                <div class="flex justify-end">
                    <date-picker
                        :value="value"
                        @change="handleChange"
                    />
                </div>
                <div ref="statsTable" v-if="stats.length > 0" class="w-full overflow-hidden shadow-xs">
                    <div class="w-full overflow-x-auto rounded-t rounded-b">
                        <table class="w-full whitespace-no-wrap">
                            <thead>
                            <tr class="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                                <th class="px-4 py-3 text-left">{{ $t('Business Day') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Bets') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Wins') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Hold') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Deposits') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Withdrawals') }}</th>
                                <th class="px-4 py-3 text-right">{{ $t('Balance') }}</th>
                            </tr>
                            </thead>
                            <tbody class="bg-gray-200 divide-y dark:divide-gray-700 dark:bg-gray-800">
                            <tr v-for="(row, index) in stats" class="text-gray-700 dark:text-gray-400">
                                <td class="px-4 py-3 text-left">
                                    {{ row.business_day }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ row.bets | currency }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ row.wins | currency }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ row.revenue | currency }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ row.deposit | currency }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ row.withdrawal | currency }}
                                </td>
                                <td class="px-4 py-3 text-right">
                                    {{ row.balance | currency }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Card from '../Components/Card';
import DatePicker from '../Components/DatePicker';
import throttle from 'lodash/throttle';

export default {
    name: "Accounting",
    props: {
        stats: Array
    },
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        from() {
            const split = this.value.split(' - ');
            return split[0];
        },
        to() {
            const split = this.value.split(' - ');
            let to = split[0];
            if (split.length > 1) {
                to = split[1];
            }

            return to;
        },
        title () {
            return this.$t('Accounting');
        }
    },
    components: {DatePicker, Card },
    data: () => ({
        value: null,
    }),
    created() {
        this.value = moment().format('DD.MM.YYYY');
    },
    methods: {
        handleChange(value) {
            this.value = value;
        },
    },
    watch: {
        value: {
            handler: throttle(function() {
                this.$inertia.replace(this.route('stats.accounting',{ from: this.from, to: this.to }));
            }, 1000),
            deep: true,
        },
    },
}
</script>

<style scoped>

</style>
